<div *ngFor="let item of phrasesQuienesSomos_items; index as i; let last = last; let isOdd=odd; let isEven=even;">
    <div class="row">
        <div class="col-lg-12" 
            [attr.data-aos]="isEven ? 'fade-left' : 'fade-right'" 
            data-aos-duration="1500"
        >
            <h3 class="fw-bold"><span class="rco text-uppercase">{{item.title}}</span> {{item.phrase}}</h3>
        </div>   
    </div>

    <div class="row" *ngIf="!last">
        <div class="col-lg-12" >
            <div class="divider"></div>
        </div>   
    </div>
</div>